import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
const API = process.env.REACT_APP_API_URL || "";

function CollectionThumbnail() {
  const [hasError, setHasError] = useState(false);
  const [collections, setCollections] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const tagURL = `${API}/collection_thumbnail`;
    
  useEffect(() => {
    fetch(tagURL)
      .then(response => response.json())
      .then((data) => {
        setCollections(data);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log("Fetch error: ", error);
        setIsLoading(false);
        setHasError(true);
      });
  }, [tagURL]);

  // console.log("Collections JSON object: ", collections);


  if (isLoading) {
    return <div className="body-container">Loading...</div>;
  }

  if (hasError) {
    return <div>Error loading collections.</div>;
  }

  if (collections.length === 0) {
    return <div>No images available.</div>;
  }

  
  return (
    <div className="collections-grid">
        {collections.map((image, index) => {
      return (
        <Link to={`/collections/${image.folder}`} key={image.folder}>
          <div className="collections-item">
            <img
              src={image.image}
              alt={image.folder}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                objectPosition: 'center',
                display: 'block',
              }}
            />
            <p>{image.folder}</p>
          </div>
        </Link>
      );
    })}
    </div>
  );
}

export default CollectionThumbnail;